export default {
  acordar_horario: 'Horário a agendar',
  aerolinea: 'Companhia aérea',
  alojamiento: 'Nome e/ou endereço da acomodação',
  asientos: 'Lugares',
  atencion: 'Atenção !!!',
  atencion_clientes: 'Atenção clientes',
  atencion_texto1: 'Efetue o pagamento da sua reserva ou crie outra rota e continue viajando.',
  atencion_texto2: '',

  buscar: 'Pesquisar',
  buscar_transfer: 'Pesquisar transfer',
  buscando: 'Pesquisando',
  btn_pagar: 'Pagar reserva',
  btn_continuar: 'Continuar',

  cancela_1: 'Cancele sua reserva!!',
  cancela_2: 'Cancelamento gratuito até 48 horas antes da viagem',
  cancela_3: '',
  cargando: 'Carregando',
  centro_ayuda: 'Centro de ajuda',
  codigo_pais_invalido: 'Código do país não válido',
  confirmar_pago_pix: 'Confirmar pagamento PIX',
  confirmar_reserva_y_pagar: 'Confirme a sua reserva e selecione a forma de pagamento...',
  control_cant_pasajeros: 'Verifique a quantidade de passageiros',
  control_fecha_mayor_igual_hoy: 'A data maior a hoje',
  cerrar: 'Fechar',
  confirmar_reservas: 'Continuar reservas',
  confirmar: 'Confirmar',
  completar_los_siguientes_datos: 'Preencher os dados',
  control_completar: 'Preencher',
  comprobante_pago_pix: 'Comprovante de pagamento PIX',
  comprobante_requerido: 'Comprovante requerido',
  configuracion_medio_no_encontrada: 'Configuração de {medio} não encontrada. Código ({codigo}).',
  condiciones: 'Ver políticas de alterações e cancelamentos',
  control_datos_pasajeros: 'Deve preencher os dados dos passageiros',
  control_email: 'Preencher email correto',
  control_movil: 'Preencher móvil',
  costo_total: 'Custo total',
  consultar_precio: 'Verifique o preço',
  cantidad_pasajeros: 'Passageiros',

  datos_de_la_reserva: 'Dados da reserva',
  datos_del_viaje: 'Dados da viagem',
  de: 'De',
  debe_aceptar_terminos: 'Você deve aceitar Términos e Condições',
  debe_aceptar_politica_cancelamiento: 'Você deve aceitar as Políticas de Cancelamento',
  dia: 'Data',
  distancia_total: 'Distância total',

  eliminar_trayecto_1: 'Apaga faixa?',
  eliminar: 'Apagar',
  err_enviando_email: 'Tem error enviando email',
  err_network_connection: 'Verifique a conexão com o servidor. Tente novamente mais tarde ou entre em contato com o suporte técnico.',
  error_alta_reserva: 'Não foi possível confirmar a reserva. Se continuar, contate o suporte e informe o código exibido.',
  estados_reserva: {
    estado_0: 'Com erro',
    estado_1: 'Emitida',
    estado_2: 'Pendiente de pago',
    estado_40: '',
    estado_45: '',
    estado_50: 'Pendiente de confirmação de pagamento no destino (pagamento a bordo)',
    estado_55: 'Pagamento no destino confirmado (pagamento a bordo)',
    estado_60: '',
    estado_70: 'Pagamento com QR code PIX pendente de confirmação',
    estado_98: 'Pago (não processado)',
    estado_99: 'Processada'
  },
  enviar_email: 'Enviar email',
  enviando_email: 'Enviando email',
  email_enviado: 'O email foi enviado',

  falta_poco: '¡Falta pouco! Preencha seus dados para prosseguir com o pagamento',
  falta_poco_pantalla3: 'Verifique se os dados da sua reserva estão corretos e confirme o pagamento',
  fecha_transfer: 'Data transfer',
  formato_comprobante_pix: 'Formatos permitidos: PDF, JPG, JPEG, PNG. Tamaño máximo: 10MB',

  hs: 'h',

  mostrar_pre_reserva: 'Abrir Pre Reserva',
  elimina_trayectos_cargados: 'Apagar faixas carregadas?',
  cancelar: 'Cancelar',
  no_elimino_trayecto: 'Não excluiu a faixa',

  datos_de_los_pasajeros: 'Dados dos passageiros',
  confirma_tus_datos_personales: 'Confirme seus dados pessoais',
  nombre_de_pasajeros: 'Nomes completos dos passageiros',
  pasajeros: 'Nome dos passageiros',
  contacto: 'Contato',
  email: 'Email',
  otros_datos: 'Outros dados',
  trayectos: 'Rotas',
  limpiar: 'Limpar',

  hora: 'Saída às',
  hora_llegada: 'Chega às',
  horario_del_vuelo: 'Horario do voo',
  hotel_posada_en: 'Hotel/pousada em',

  intercambiar_origen_destino: 'Trocar origem e destino',

  terminos_y_condiciones: 'Termos e condições',
  confirmar_reserva: 'Confirmar reserva',
  boton_condiciones: 'Ver políticas',
  metodo_de_pago: 'Método de pagamento',
  plataforma_de_pago: 'Plataforma de pagamento',
  saliendo_de: 'Saindo de',
  conozca_stripe: 'Clic... Conheça Stripe',
  nombres_completos: 'Nomes completos',
  detalle_reserva: 'Detalhes da reserva',

  limpiar_busqueda: 'Limpar busca',
  llegando_a: 'Chegando a',

  maletas_1: 'Malas por pessoas',
  maletas_2: 'Uma mala média',
  maletas_3: 'Uma mala pequena',
  modifica_1: 'Modifique sua reserva',
  modifica_2: 'Modifique sua reserva gratuitamente a qualquer momento',
  modifica_3: '',
  monto_a_pagar: 'Valor do pagamento',
  medios_de_pago: 'Meios de pagamento',
  medios_de_pago_seleccione: 'Selecione a forma de pagamento',
  movil: 'Celular',
  movil_whatsapp: 'Whatsapp - celular',

  no_encontro_resultado: 'Não encontrou resultado',
  no_hay_resultados: 'Não há resultados',
  nro_vuelo: 'Número do voo',

  pagar: 'Pagar agora',
  pagar_reserva: 'Pagar reserva',
  pago_con_tarjeta: 'Pagamento com cartão de crédito ou débito',
  pago_con_tarjeta_txt: 'Pague com cartão de crédito ou débito',
  pago_con_paypal: 'Pagamento com Paypal',
  pago_con_paypal_txt: 'Pagar com conta Paypal',
  pago_con_pix: 'Pagamento com QR code PIX',
  pago_con_pix_pendiente_de_confirmacao: 'Pagamento com QR code PIX pendente de confirmação',
  pago_con_pix_txt: 'Pague com QR code PIX',
  pago_a_bordo: 'Pagamento no destino (dinheiro, a bordo)',
  pago_a_bordo_txt: 'Pague em dinheiro na chegada',
  pago_a_bordo_representante: 'Um de nossos representantes entrará em contato com você para confirmar a reserva',
  pago_a_bordo_completar_datos: 'Você deve preencher: contato, email e celular',
  pago_a_bordo_confirmado: 'Excelente, confirmamos seu pagamento no destino (pagamento a bordo)',
  pago_pix_instrucciones: 'Leia o código QR com sua aplicação, pague e confirme o pagamento carregando o comprovante',
  pago_por_stripe: 'Confirme o pagamento da sua reserva com cartão de crédito ou débito',
  para: 'Para',
  precio: 'Preço',
  precio_por_pasajero: 'Preço por passageiro',
  politica_privacidad: 'Política de privacidade',
  preparando_pago_paypal: 'Só uns segundos, preparando o pagamento no Paypal ...',
  preparando_pago_paguelofacil: 'Só uns segundos, preparando o pagamento no Páguelo Fácil ...',
  preparando_pago_pix: 'Só uns segundos, preparando o pagamento com QR code PIX ...',
  preparando_pago_stripe: 'Só uns segundos, preparando o pagamento no Stripe ...',

  reserva: 'Reserva',
  reserva_id: 'Reserva id',
  reservar: 'Reservar',
  ruta: 'Rota',

  seleccionar_comprobante_pix: 'Selecionar comprovante de pagamento PIX',
  seleccionar_horario: 'Selecione horário',
  seleccionar_otro_trayecto: 'Adicionar outra rota',
  seleccione_ambos_puntos: 'Selecione ambos pontos para ver a rota',
  stripe_no_devolvio_url: 'Verifique seu pagamento porque Stripe não retornou amostra de URL de reserva',
  sesion_expiro: 'A sessão expirou',
  servicios: 'Serviços',
  servicios_otra_informacion: 'Mais informações para sua viagem',
  sub_total: 'Subtotal',

  modificar_reserva: 'Modificar reserva',
  cancelar_reserva: 'Cancelar reserva',
  reserva_confirmada: 'Sua reserva foi confirmada, em breve você receberá os detalhes da viagem',
  reserva_no_confirmada: 'Sua reserva não foi confirmada',
  reserva_ya_no_disponible: 'Esta reserva não está mais disponível',
  medios_pagos_no_configurados: 'Métodos de pagamento sim configuração',
  reserva_pago_a_bordo: 'Pagamento da reserva a bordo. Nossa equipe entrará em contato com você para confirmar o mesmo',
  reserva_link_pago: 'Reserva pendente de envio e confirmação de pagamento via link de pagamento',
  reserva_pendiente: 'Reserva pendente de pagamento',
  reserva_pago_a_bordo_confirmada: 'Reserva com pagamento a bordo confirmado',
  no_gracias: 'Não, obrigado',
  espero_contacten: 'Espero que você entre em contato comigo',

  telefono_contacto: 'Movil contato',
  telefono_contacto_msq: 'Número de celular para contato com você por qualquer eventualidade',
  telefono_placeholder: 'Número de celular',
  telefono_placeholder_msg: 'Número de celular para contato com o passageiro principal',
  tiempo_estimado: 'Tempo estimado de viagem',
  tipo_servicio: 'Serviço',
  tipo_transfer: {
    bu: 'Transfer regular bus',
    mb: 'Transfer regular mini bus',
    va: 'Transfer regular van',
    t3: 'Transfer privado de 1 a 3 pessoas',
    t5: 'Transfer privado até 5 pessoas',
    t6: 'Transfer privado até 6 pessoas',
    bp: 'Transfer privado bus',
    mp: 'Transfer privado mini bus',
    vp: 'Transfer privado van até 13 pessoas',
    auto03: 'Transfer privado de carro 1 a 3 pessoas',
    auto08: 'Transfer privado de carro 4 a 8 pessoas',
    auto12: 'Transfer privado de carro 9 a 12 pessoas',
    auto16: 'Transfer privado de carro 13 a 16 pessoas',
    auto20: 'Transfer privado de carro 17 a 20 pessoas',
    auto25: 'Transfer privado de carro 21 a 25 pessoas',
    auto30: 'Transfer privado de carro 26 a 30 pessoas',
    hasta4: 'Privado até 4 passageiros',
    hasta5: 'Privado até 5 passageiros',
    hasta5_suburban: 'Suburban até 5 passageiros',
    hasta6: 'Privado até 6 passageiros',
    hasta8: 'Privado até 8 passageiros',
    hasta10: 'Privado até 10 passageiros',
    hasta13: 'Privado até 13 passageiros',
    hasta17: 'Privado até 17 passageiros',
    hasta22: 'Privado até 22 passageiros'
  },
  transfer: 'Transfer',
  transfer_privado: 'Transfer privado',
  transfer_regular: 'Transfer regular',
  transfer_horario: 'Horário do transfer',
  trayecto: 'Rota',
  trayectos_intercambiados: 'Rotas trocadas',
  te_enviamos_voucher: 'Enviaremos aqui o seu voucher de reserva',
  total: 'Monto',
  terminos: 'Declaro que li a Política de Privacidade e que aceito os Termos e Condições de Reserva e os Termos e Condições de Transporte',

  ordinal_trayecto: {
    ordinal_1: 'Primeiro',
    ordinal_2: 'Segundo',
    ordinal_3: 'Terceiro',
    ordinal_4: 'Quarto',
    ordinal_5: 'Quinto',
    ordinal_6: 'Sexto',
    ordinal_7: 'Setimo'
  },

  ver_ruta_en_mapa: 'Ver rota no mapa',
  ver_punto_en_mapa: 'Ver ponto no mapa',
  verificar_parametros: 'Verificar os parâmetros',
  version: 'v.',
  powered_by: 'Powered by',
  volver_atras: 'Voltar'

}
